export default __webpack_public_path__ + "static/media/security-icon1.e4a8263f.svg";